import { render, staticRenderFns } from "./Direction.vue?vue&type=template&id=5b2542ac&scoped=true&lang=true&"
import script from "./Direction.vue?vue&type=script&lang=js&"
export * from "./Direction.vue?vue&type=script&lang=js&"
import style0 from "./Direction.vue?vue&type=style&index=0&id=5b2542ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2542ac",
  null
  
)

export default component.exports